import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'
import { ListingResponse } from '~in-app/types/api.dto'

import { HostAdminTemplateListQuery, TemplateListQuery, Templates } from './types'

export const fetchTemplateList = async (params?: { abortCtrl?: AbortController | AbortSignal, query?: TemplateListQuery }) => {
  return wretchClient
    .url('/admin/1.0/products/templates')
    .signal(params?.abortCtrl)
    .query(params?.query || {})
    .get()
    .json<ListingResponse<Templates>>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
export const fetchHostAdminTemplateList = async (params?: { abortCtrl?: AbortController | AbortSignal, query?: HostAdminTemplateListQuery }) => {
  return wretchClient
    .url('/admin/1.0/products/templates/by-host-admin')
    .signal(params?.abortCtrl)
    .query(params?.query || {})
    .get()
    .json<ListingResponse<Templates>>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
export const fetchTemplateDetails = async (params: { id: string, abortCtrl?: AbortController | AbortSignal }) => {
  return wretchClient
    .url(`/admin/1.0/products/templates/${params.id}`)
    .signal(params?.abortCtrl)
    .get()
    .json<[Templates]>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const deleteTemplates = async (id: string) => {
  return wretchClient
    .url(`/admin/1.0/products/templates/${id}`)
    .delete()
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const addTemplates = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/products/templates`)
    .post([value])
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
export const updateTemplates = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/products/templates`)
    .put([value])
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
